import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_68e540d5 from 'nuxt_plugin_plugin_68e540d5' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_portalvue_6c2619f0 from 'nuxt_plugin_portalvue_6c2619f0' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_buefy_8b19f8d8 from 'nuxt_plugin_buefy_8b19f8d8' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_nuxtvuexroutersync_72fa672b from 'nuxt_plugin_nuxtvuexroutersync_72fa672b' // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_dd959168 from 'nuxt_plugin_nuxtuseragent_dd959168' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_ed0a842a from 'nuxt_plugin_cookieuniversalnuxt_ed0a842a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_sentryserver_12aa5df2 from 'nuxt_plugin_sentryserver_12aa5df2' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_de1d4102 from 'nuxt_plugin_sentryclient_de1d4102' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_0ed7f77a from 'nuxt_plugin_axios_0ed7f77a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_6b3effd9 from 'nuxt_plugin_gtm_6b3effd9' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_workbox_b51716c2 from 'nuxt_plugin_workbox_b51716c2' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_coconala_820d45d2 from 'nuxt_plugin_coconala_820d45d2' // Source: ../plugins/coconala (mode: 'all')
import nuxt_plugin_util_56d0d459 from 'nuxt_plugin_util_56d0d459' // Source: ../plugins/util (mode: 'all')
import nuxt_plugin_blogserviceutil_14a6416e from 'nuxt_plugin_blogserviceutil_14a6416e' // Source: ../plugins/blog-service-util (mode: 'all')
import nuxt_plugin_blogwidgetutil_422a7a17 from 'nuxt_plugin_blogwidgetutil_422a7a17' // Source: ../plugins/blog-widget-util (mode: 'all')
import nuxt_plugin_globalcomponents_21f90eee from 'nuxt_plugin_globalcomponents_21f90eee' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_vuefilters_6a64467d from 'nuxt_plugin_vuefilters_6a64467d' // Source: ../plugins/vue-filters (mode: 'all')
import nuxt_plugin_affiliate_35c88154 from 'nuxt_plugin_affiliate_35c88154' // Source: ../plugins/affiliate (mode: 'server')
import nuxt_plugin_affiliateclient_6d2764d4 from 'nuxt_plugin_affiliateclient_6d2764d4' // Source: ../plugins/affiliate_client (mode: 'client')
import nuxt_plugin_couponbanner_2d385aee from 'nuxt_plugin_couponbanner_2d385aee' // Source: ../plugins/coupon_banner (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02' // Source: ../plugins/axios (mode: 'client')
import nuxt_plugin_vueintersection_1795c947 from 'nuxt_plugin_vueintersection_1795c947' // Source: ../plugins/vue-intersection (mode: 'client')
import nuxt_plugin_vuenotification_30f227a9 from 'nuxt_plugin_vuenotification_30f227a9' // Source: ../plugins/vue-notification (mode: 'client')
import nuxt_plugin_vueautosize_62effbee from 'nuxt_plugin_vueautosize_62effbee' // Source: ../plugins/vue-autosize (mode: 'client')
import nuxt_plugin_vueawesomeswiper_0e14f460 from 'nuxt_plugin_vueawesomeswiper_0e14f460' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_vuelidate_1613848c from 'nuxt_plugin_vuelidate_1613848c' // Source: ../plugins/vuelidate (mode: 'client')
import nuxt_plugin_vuescrollto_15afb874 from 'nuxt_plugin_vuescrollto_15afb874' // Source: ../plugins/vue-scrollto (mode: 'client')
import nuxt_plugin_vuesocialsharing_54b515ba from 'nuxt_plugin_vuesocialsharing_54b515ba' // Source: ../plugins/vue-social-sharing (mode: 'client')
import nuxt_plugin_vueyoutube_6236cda5 from 'nuxt_plugin_vueyoutube_6236cda5' // Source: ../plugins/vue-youtube (mode: 'all')
import nuxt_plugin_vuerouter_95aec6f2 from 'nuxt_plugin_vuerouter_95aec6f2' // Source: ../plugins/vue-router (mode: 'client')
import nuxt_plugin_vue2touchevents_3283e531 from 'nuxt_plugin_vue2touchevents_3283e531' // Source: ../plugins/vue2-touch-events (mode: 'client')
import nuxt_plugin_webvitals_3405b197 from 'nuxt_plugin_webvitals_3405b197' // Source: ../plugins/web-vitals (mode: 'client')
import nuxt_plugin_vuetagsinput_3523d553 from 'nuxt_plugin_vuetagsinput_3523d553' // Source: ../plugins/vue-tagsinput (mode: 'client')
import nuxt_plugin_setattribute_0a7fc47a from 'nuxt_plugin_setattribute_0a7fc47a' // Source: ../plugins/set-attribute (mode: 'client')
import nuxt_plugin_sentryplugin_7e61c66a from 'nuxt_plugin_sentryplugin_7e61c66a' // Source: ../plugins/sentry-plugin (mode: 'client')
import nuxt_plugin_vuetoast_ebd61dae from 'nuxt_plugin_vuetoast_ebd61dae' // Source: ../plugins/vue-toast (mode: 'client')
import nuxt_plugin_meta_713d65b2 from 'nuxt_plugin_meta_713d65b2' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ja"},"title":"ココナラ","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fcoconala.com\u002F"},{"hid":"og:title","property":"og:title","content":"ココナラ - プロが集まる日本最大級のスキルマーケット"},{"hid":"og:site_name","property":"og:site_name","content":"ココナラ"},{"hid":"og:description","property":"og:description","content":"ココナラは、いろんなジャンルの「仕事」や「相談」をネットショッピングのように早く・簡単・おトクに依頼できます！ロゴや名刺などのデザイン、動画・サイト制作、お悩み相談など、ビジネスやプライベートで自分ではできないことをプロや専門家に依頼しませんか？No.1スキルマーケットのココナラ！"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"fb:app_id","property":"fb:app_id","content":"351718318182401"},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@coconala"},{"property":"og:locale","content":"ja_JP"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fcoconala.com\u002Fimages\u002Ffacebook.png"},{"name":"apple-mobile-web-app-title","content":"ココナラ"},{"name":"application-name","content":"ココナラ"},{"name":"msapplication-TileColor","content":"#e8e3df"},{"name":"msapplication-TileImage","content":"\u002Fmstile-144x144.png"},{"name":"Copyright","content":"coconala Inc."},{"name":"referrer","content":"no-referrer-when-downgrade"}],"script":[{"src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.min.js?features=es6%2Ces7%2Ces2017%2CObject.fromEntries%2CElement.prototype.scroll","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5X65DX')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","href":"\u002Ffavicon.svg","type":"image\u002Fsvg+xml"},{"rel":"icon","sizes":"192x192","href":"\u002Fandroid-chrome.png","type":"image\u002Fpng"},{"rel":"icon","sizes":"96x96","href":"\u002Ffavicon.png","type":"image\u002Fpng"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5X65DX&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_68e540d5 === 'function') {
    await nuxt_plugin_plugin_68e540d5(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_6c2619f0 === 'function') {
    await nuxt_plugin_portalvue_6c2619f0(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_8b19f8d8 === 'function') {
    await nuxt_plugin_buefy_8b19f8d8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_72fa672b === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_72fa672b(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_dd959168 === 'function') {
    await nuxt_plugin_nuxtuseragent_dd959168(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_ed0a842a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_ed0a842a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_12aa5df2 === 'function') {
    await nuxt_plugin_sentryserver_12aa5df2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_de1d4102 === 'function') {
    await nuxt_plugin_sentryclient_de1d4102(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0ed7f77a === 'function') {
    await nuxt_plugin_axios_0ed7f77a(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_6b3effd9 === 'function') {
    await nuxt_plugin_gtm_6b3effd9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_b51716c2 === 'function') {
    await nuxt_plugin_workbox_b51716c2(app.context, inject)
  }

  if (typeof nuxt_plugin_coconala_820d45d2 === 'function') {
    await nuxt_plugin_coconala_820d45d2(app.context, inject)
  }

  if (typeof nuxt_plugin_util_56d0d459 === 'function') {
    await nuxt_plugin_util_56d0d459(app.context, inject)
  }

  if (typeof nuxt_plugin_blogserviceutil_14a6416e === 'function') {
    await nuxt_plugin_blogserviceutil_14a6416e(app.context, inject)
  }

  if (typeof nuxt_plugin_blogwidgetutil_422a7a17 === 'function') {
    await nuxt_plugin_blogwidgetutil_422a7a17(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_21f90eee === 'function') {
    await nuxt_plugin_globalcomponents_21f90eee(app.context, inject)
  }

  if (typeof nuxt_plugin_vuefilters_6a64467d === 'function') {
    await nuxt_plugin_vuefilters_6a64467d(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_affiliate_35c88154 === 'function') {
    await nuxt_plugin_affiliate_35c88154(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_affiliateclient_6d2764d4 === 'function') {
    await nuxt_plugin_affiliateclient_6d2764d4(app.context, inject)
  }

  if (typeof nuxt_plugin_couponbanner_2d385aee === 'function') {
    await nuxt_plugin_couponbanner_2d385aee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_fb9c9a02 === 'function') {
    await nuxt_plugin_axios_fb9c9a02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueintersection_1795c947 === 'function') {
    await nuxt_plugin_vueintersection_1795c947(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuenotification_30f227a9 === 'function') {
    await nuxt_plugin_vuenotification_30f227a9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueautosize_62effbee === 'function') {
    await nuxt_plugin_vueautosize_62effbee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_0e14f460 === 'function') {
    await nuxt_plugin_vueawesomeswiper_0e14f460(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelidate_1613848c === 'function') {
    await nuxt_plugin_vuelidate_1613848c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_15afb874 === 'function') {
    await nuxt_plugin_vuescrollto_15afb874(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesocialsharing_54b515ba === 'function') {
    await nuxt_plugin_vuesocialsharing_54b515ba(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_6236cda5 === 'function') {
    await nuxt_plugin_vueyoutube_6236cda5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuerouter_95aec6f2 === 'function') {
    await nuxt_plugin_vuerouter_95aec6f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2touchevents_3283e531 === 'function') {
    await nuxt_plugin_vue2touchevents_3283e531(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webvitals_3405b197 === 'function') {
    await nuxt_plugin_webvitals_3405b197(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetagsinput_3523d553 === 'function') {
    await nuxt_plugin_vuetagsinput_3523d553(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setattribute_0a7fc47a === 'function') {
    await nuxt_plugin_setattribute_0a7fc47a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryplugin_7e61c66a === 'function') {
    await nuxt_plugin_sentryplugin_7e61c66a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoast_ebd61dae === 'function') {
    await nuxt_plugin_vuetoast_ebd61dae(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_713d65b2 === 'function') {
    await nuxt_plugin_meta_713d65b2(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
